import React, {useCallback, useState} from 'react';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Icon,
    IconButton,
    useModal
} from '@jutro/components';
import { Grid, GridItem } from '@jutro/layout';
import _ from 'lodash';
import styles from './AdacCookiesModal.module.scss';

const COOKIE_APPROVAL_NAME = 'adac_cookies_approval';

function AdacCookieExplanationPopup({ isOpen, onResolve }) {
    return (
        <ModalNext isOpen={isOpen} className={styles.cookieExplanationModal}>
            <ModalHeader
                title="Unbedingt erforderlich"
                status="warning"
                icon="mi-info"
            />
            <ModalBody>
                <div className={styles.cookieExplanation}>
                    <div className={styles.cookieExplanationTitle}>
                        <Icon icon="mi-check_box" iconColor="neutral" />
                        <h3>Ambulanz Service Online</h3>
                    </div>
                    <br />
                    <h5>Kurzbeschreibung</h5>
                    <br />
                    Der Ambulanz-Service Online ist ein Web-Dienst der ADAC Versicherung AG,
                    der von ADAC Mitgliedern, Versicherten der ADAC Versicherung AG und Dritten
                    (z. B. Angehörige, Geschädigte), zur digitalen Kontaktaufnahme im Schadenfall
                    sowie zur digitalen Übermittlung von Informationen, Dokumenten/Fotos
                    zur Bearbeitung des Schadenfalls und Organisation von Hilfeleistungen
                    genutzt werden kann.
                    <br />
                    <br />
                    <h5>Verarbeitungsunternehmen</h5>
                    <br />
                    ADAC Versicherung AG
                    <br />
                    <br />
                    <h5>Datenverarbeitungszwecke</h5>
                    <br />
                    Zweck des Web-Portals „Ambulanz-Service Online“ sind die systemunterstützte
                    Fallannahme medizinischer Schadenfälle sowie die anschließende Organisation
                    von Hilfeleistungen in akuten Schadenfällen mit den Kunden und ggf. damit
                    verbundener Leistungen der ADAC Versicherung AG. Dafür setzen wir beim Senden
                    der im Web-Service eingegebenen Daten an ADAC-Systeme Cookies ein,
                    um die gesendeten Daten bei Verteilung des Datenverkehrs auf mehrere
                    ADAC Server zum Lastausgleich eindeutig einer bestimmten Browser-Sitzung
                    zuordnen zu können. Die Cookies und Daten, welche im Browser des Nutzers
                    gesetzt und verarbeitet werden, dienen nicht der persönlichen Identifizierung
                    oder der Erhebung persönlicher Daten.
                    <br />
                    <br />
                    <h5>Verwendete Technologien</h5>
                    <br />
                    Cookie „JSession“
                    <br />
                    Cookie „NSC_MCWT (*)“
                    <br />
                    Local Storage des Browsers
                    <br />
                    <br />
                    <h5>Erhobene Daten</h5>
                    <br />
                    <ul>
                        <li>
                            Cookies: Sitzungs ID
                        </li>
                        <li>
                            Im lokalen Speicher (sog. Local Storage) des Endgerätes
                            werden folgende Informationen gespeichert:
                            <ul>
                                <li>
                                    Log level – Bei auftretenden technischen Fehlern
                                    wird der Schweregrad des Fehlers lokal bis zum Ende
                                    der Browser Sitzung gespeichert
                                </li>
                                <li>
                                    Die ausgewählte Sprache zur Anzeige des Web-Service
                                    auf Deutsch oder in anderen Sprachen
                                </li>
                                <li>
                                    Der ausgewählte Standort
                                </li>
                                <li>
                                    Information über Ihre Interaktion mit dem Cookie-Banner.
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <br />
                    <h5>Rechtliche Grundlage</h5>
                    <br />
                    § 25 Abs. 2 Nr. 2 TTDSG für das Speichern der Cookies im Endgerät
                    und Zugriff darauf; Art. 6 Abs. 1 S. 1 lit. f DSGVO für
                    die Folgeverarbeitungen (Bereitstellung des Web-Portals
                    „Ambulanz-Service Online“)
                    <br />
                    <br />
                    <h5>Ort der Verarbeitung</h5>
                    <br />
                    Deutschland
                    <br />
                    <br />
                    <h5>Aufbewahrungsfrist</h5>
                    <br />
                    Local Storage: bis zur Löschung durch den Nutzer
                    <br />
                    <br />
                    <h5>Weitergabe an Drittländer</h5>
                    <br />
                    keine
                    <br />
                    <br />
                    <h5>Datenempfänger</h5>
                    <br />
                    ADAC Versicherung AG
                    <br />
                    <br />
                    <h5>Unser Hosting-Dienstleister</h5>
                    <br />
                    matrix technology GmbH
                    <br />
                    Nymphenburger Straße 1
                    <br />
                    80335 München
                    <br />
                    <br />
                    <h5>Datenschutzbeauftragter</h5>
                    <br />
                    <a href="mailto:dsb-mail@adac.de">dsb-mail@adac.de</a>
                    <br />
                    <br />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onResolve}>
                    Speichern und schliessen
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

function AdacCookiesDetailsPopup({ isOpen, onResolve }) {
    const { showModal } = useModal();
    const openExplanation = () => {
        showModal(
            <AdacCookieExplanationPopup />
        );
    };

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader
                title="Privatsphäre-Einstellungen"
                status="warning"
                icon="mi-info"
            />
            <ModalBody>
                <Grid columns={['1fr', '30px', '30px']} gap="none">
                    <GridItem className={styles.consentHeader}>
                        <h4>Unbedingt erforderlich</h4>
                    </GridItem>
                    <GridItem>
                        <IconButton
                            icon="mi-help"
                            iconColor="neutral"
                            onClick={openExplanation}
                        />
                    </GridItem>
                    <GridItem>
                        <IconButton
                            icon="mi-check_box"
                            iconColor="neutral"
                            onClick={openExplanation}
                        />
                    </GridItem>
                    <GridItem className={styles.consentHeader}>
                        &nbsp;&nbsp;ADAC Ambulanz Service
                    </GridItem>
                    <GridItem>
                        <IconButton
                            icon="mi-help"
                            iconColor="neutral"
                            onClick={openExplanation}
                        />
                    </GridItem>
                    <GridItem>
                        <IconButton
                            icon="mi-check_box"
                            iconColor="neutral"
                            onClick={openExplanation}
                        />
                    </GridItem>
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onResolve}>
                    Speichern und schliessen
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

export default function AdacCookiesModal() {
    /* eslint-disable-next-line max-len */
    const [cookieApproval, setCookieApproval] = useState(localStorage.getItem(COOKIE_APPROVAL_NAME));
    const { showModal } = useModal();

    const saveApproval = useCallback((chosenCookieApproval) => {
        localStorage.setItem(COOKIE_APPROVAL_NAME, chosenCookieApproval);
        setCookieApproval(chosenCookieApproval);
    }, []);

    const openDetails = () => {
        showModal(
            <AdacCookiesDetailsPopup />
        );
    };

    return (
        <>
            <div className={styles.container} style={{ display: _.isNil(cookieApproval) ? 'flex' : 'none' }}>
                <div className={styles.content}>
                    <span>
                        Auf Grundlage einer gesetzlichen Erlaubnis, ohne dass es Ihrer Einwilligung
                        bedarf, verwenden wir (Unternehmen unter der Marke ADAC; siehe&nbsp;
                        <a href="https://www.adac.de/datenschutz-dsgvo/online/">Datenschutzinformation Ziffer 1.</a>
                        )
                        nur technisch erforderliche Cookies, Tags und Zählpixel, um Ihnen
                        Funktionen der Website zur Verfügung
                        zu stellen. Ihre Einwilligung können Sie jederzeit mit
                        Wirkung für die Zukunft über den Link&nbsp;
                        <a href="https://www.adac.de/datenschutz-dsgvo/cookie-einstellungen/">Cookie-Einstellungen</a>
                        &nbsp;(siehe Fußzeile unserer Websites) widerrufen.
                    </span>
                    <h3>EINWILLIGUNG</h3>
                    <span>
                        Durch Klicken auf&nbsp;
                        <b>„Einwilligung“</b>
                        &nbsp;willigen Sie ein, dass wir – über
                        die unbedingt erforderlichen
                        hinaus – Informationen (Cookies, Tags und Zählpixel)
                        zu folgenden Zwecken in Ihrem Endgerät
                        setzen und darauf zugreifen sowie anschließend
                        Ihre Daten entsprechend verarbeiten und
                        an Partnerunternehmen (&quot;Datenempfänger&quot;) weitergeben dürfen:
                    </span>
                    <ul>
                        <li>
                            Weiterentwicklung von www.adac.de: Messung der
                            Nutzung von adac.de (Statistiken und Analysen), um Inhalte,
                            Funktionen und Ergonomie der Website zu verbessern
                        </li>
                        <li>
                            Werbung auf Basis von Pseudonymen: Messung der
                            Nutzung von adac.de unter Verwendung von Pseudonymen für Werbezwecke
                        </li>
                        <li>
                            Einsatz von Werbe-Netzwerken zur Anzeige individueller
                            Werbung auf www.adac.de und dritten Websites:
                            Dazu verknüpfen die Werbe-Netzwerkbetreiber Nutzungsdaten
                            der Besucher von www.adac.de mit anderen Daten wie Suchverlauf,
                            persönliche Accounts, Nutzungsdaten anderer Geräte,
                            die dem Werbe-Netzwerkbetreiber zum jeweiligen Besucher vorliegen.
                        </li>
                    </ul>
                    <span>
                        Über &quot;Informationen &amp; Einstellungen&quot; erhalten Sie weitere
                        Informationen und können dort die Einwilligung auch nur für
                        einzelne Zwecke und einzelne Partnerunternehmen abgeben
                        Wenn Sie auf&nbsp;
                        <b>&quot;Ablehnung&quot;</b>
                        &nbsp;klicken, geben Sie uns keine
                        Einwilligung und können Ihren Besuch unserer Websites
                        trotzdem mit den unbedingt erforderlichen Cookies,
                        Tags und Zählpixeln fortsetzen.
                    </span>
                </div>
                <div className={styles.buttons}>
                    <Button onClick={openDetails} size="medium">Informationen &amp; Einstellungen</Button>
                    <Button onClick={() => saveApproval(false)} className={styles.red} size="medium">Ablehnung</Button>
                    <Button onClick={() => saveApproval(true)} className={styles.green} size="medium">Einwilligung</Button>
                </div>
            </div>
        </>
    );
}
